import React from "react";
import { CardLayout } from "components/cardLayout";
import { getEstFlowEstimateDetails, getEstimatorInventory } from "../../core/services/moveDetailsByCustomer"
import { getCustomerDetails } from 'core/services/getCustomerDetailsService'
import { getEstimatorPacking } from 'core/services/getEstimatorPacking'
import Spinner from '../spinner/spinner';
import { MoveListCard } from "components/moveListCard";
import "./PackingMaterialCard.scss"
import { ArrowDropDown, ArrowDropUp } from "@material-ui/icons";
//import { sign } from "crypto";

export interface PackingMaterialCardProps {
    onClick?(): void;
}

export interface PackingMaterialCardState {
    loading: boolean
    data: any
    transportData: any;
    responseEstDetail: any,
    inventoryData: any,
    inventoryUniqueRow: any,
    customerDetails: any
    EstimatorDetails: any
    PackingMaterial: any
    title: string,
    subTitle: string,
    footerTiltle: string,
    openPackMaterial: boolean,
    openFormEstimate: boolean,
    openOther: boolean,
    view: any

}


class PackingMaterialCard extends React.Component<PackingMaterialCardProps, PackingMaterialCardState> {
    private _isMounted: boolean = false
    sigCanvasFirst: any;
    sigCanvasSecond: any;
    firstSignPadRef: any;
    sliderRef: any;

    constructor(props: PackingMaterialCardProps) {
        super(props);
        //debugger;
        this.state = {
            loading: true,
            transportData: [],
            responseEstDetail: {},
            inventoryData: [],
            inventoryUniqueRow: [],
            customerDetails: {},
            EstimatorDetails: {},
            PackingMaterial: [],
            footerTiltle: "",
            title: "",
            subTitle: "",
            data: {},
            openPackMaterial: false,
            view: "",
            openFormEstimate: false,
            openOther: false,

        };


    }

    clearFirst = () => {
        // if(this.props.formControl){
        //     this.props.formControl.reset();
        // }
        this.sigCanvasFirst.clear();

    }
    componentDidMount() {

        console.log("componentDidMount")

        //this.setState({loading:false});
        this._isMounted = true;
        var cid = (localStorage.getItem("CID") || "");
        var securetoken = localStorage.getItem("securetoken") || "";
        var cusDetails: any = localStorage.getItem("customerDetails")

        let customerDetails = JSON.parse(cusDetails)
        console.log("Local Customer Data INNNNNN", customerDetails);
        this.setState({ customerDetails: customerDetails });
        Promise.all([
            this.getEstFlowEstimateDetails(cid),
            this.getEstimatorInventory(cid),
            this.getEstimatorPacking(cid)
        ]).then((response: any[]) => {

            if (this._isMounted) {
                console.clear()
                var inventory = response[1];
                this.setState({ inventoryData: inventory });

                console.log("RESPONSE", response[0])
                var inventoryUniqueNames: any = [];
                const inventoryObj = this.state.inventoryData.filter((item: { name: any; }) => {
                    var idx = inventoryUniqueNames.findIndex((x: { name: any; }) => x.name == item.name);
                    if (idx <= -1) {
                        inventoryUniqueNames.push({ name: item.name });
                    }
                });
                this.setState({ inventoryUniqueRow: inventoryUniqueNames, loading: false });

                // PACKING
                const PackingMaterial = response[2];
                this.setState({
                    title: "Description",
                    subTitle: "Quality",
                    footerTiltle: "Packing Materials & Containers",
                    PackingMaterial: PackingMaterial,
                    EstimatorDetails: response[0]?response[0][0]:{}
                })

            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
        console.log("componentWillUnmount")
    }

    async getCustomerDetails(cid: string, securetoken: string) {
        return await getCustomerDetails(cid, securetoken)
    }

    async getEstFlowEstimateDetails(cid: string) {
        return await getEstFlowEstimateDetails(cid)
    }

    async getEstimatorInventory(cid: string) {
        return await getEstimatorInventory(cid)
    }

    // cgetEstimatorPacking
    async getEstimatorPacking(cid: string) {
        return await getEstimatorPacking(cid)
    }



    renderInventory() {
        console.log(this.state.inventoryUniqueRow)
        const items = this.state.inventoryUniqueRow.map((item: any, index: number) => {

            var nestedData: any = [];
            var inventData = this.state.inventoryData.filter((itemObj: any) => {
                if (itemObj.name.match(item.name)) {
                    var obj = { type: itemObj.materialDescription, summary: itemObj.packingType, amount: itemObj.qTY, hour: '' }
                    nestedData.push(obj);
                    return obj;
                }
            });

            // var totalQty = this.sumProperty(nestedData, 'amount');
            // var totalLbs = this.sumProperty(inventData, 'cubeQTY');

            // return <MoveListCard
            //     key={index}
            //     title={item.name}
            //     data={nestedData}
            // />

            return <div>
                <div style={{ display: "flex", width: "100%" }}>
                    <p className="labelEst">{item.name}</p>
                </div>
                <div className="contentEst">
                    {
                        nestedData.map((ele: any, i: any) => (
                            <div className={"listItemEst"}>
                                <div>
                                    <p>{ele.type}</p>
                                </div>
                                <h3>{ele.amount}</h3>
                            </div>

                        ))}
                </div>
            </div>
        })

        return items;
    }
    openPackingMaterial = () => {
        const { openPackMaterial } = this.state;
        this.setState({ openPackMaterial: !openPackMaterial, openFormEstimate: false, openOther: false });
    }
    openFormEstimate = () => {
        const { openPackMaterial, openFormEstimate } = this.state;
        this.setState({ openPackMaterial: false, openOther: false, openFormEstimate: !openFormEstimate });
    }
    openOtherCharges = () => {
        const { openPackMaterial, openFormEstimate, openOther } = this.state;
        this.setState({ openPackMaterial: false, openFormEstimate: false, openOther: !openOther });
    }
    render() {
        const { title, subTitle, footerTiltle, openPackMaterial, view, inventoryUniqueRow, openFormEstimate, openOther ,EstimatorDetails} = this.state;
        console.log("openPackMaterial", openPackMaterial)
        let total = 0
        const packingMaterialcost=(parseFloat(EstimatorDetails?.packingCost)+parseFloat(EstimatorDetails?.materialCost)).toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})
        return (
            
            this.state.loading ? <Spinner /> :
                <div>
                    <CardLayout>

                        <div className="packingItem" onClick={this.openPackingMaterial}>
                            <div className="packingItemHead">
                                <h1>Packing Materials</h1>
                                {openPackMaterial ? <ArrowDropUp color="disabled" /> : <ArrowDropDown color="disabled" />}
                            </div>
                            {openPackMaterial ? <div className="packingItemContent">
                                <div style={{ display: "flex", width: "100%" }}>
                                    <p className="label">{this.state.title}</p>
                                    <span className="labelSubtitle">{this.state.subTitle}</span>
                                </div>
                                <div className="content">
                                    {
                                        this.state.PackingMaterial.map((ele: any, i: any) => (
                                            <div className={i % 2 === 0 ? "listItem" : "listItemNoBaground"}>
                                                <div>
                                                    <p>{ele.materialDescription}</p>
                                                </div>
                                                <h3>{ele.qTY}</h3>
                                            </div>

                                        ))}
                                    <div style={{ display: "flex", width: "100%",justifyContent:"space-between" }}>
                                        <div className="packingChargeTotal packTitle">{footerTiltle}</div>
                                        <div className={"packingChargeTotal"}>${packingMaterialcost}</div>
                                        
                                    </div>
                                </div>
                            </div> : null}
                        </div>
                        <br />
                        <div className="packingItem" onClick={this.openFormEstimate}>
                            <div className="packingItemHead">
                                <h1>Items From Estimate</h1>
                                {openFormEstimate ? <ArrowDropUp color="disabled" /> : <ArrowDropDown color="disabled" />}
                            </div>
                            {openFormEstimate ? <div className="packingItemContent">
                                {this.renderInventory()}
                            </div> : null}
                        </div>
                        <br />
                        <div className="packingItem" onClick={this.openOtherCharges}>
                            <div className="packingItemHead">
                                <h1>Other Charges:</h1>
                                {openOther ? <ArrowDropUp color="disabled" /> : <ArrowDropDown color="disabled" />}
                            </div>
                            {openOther ? <div className="packingItemContent">
                                <div className="content">
                                    <div className={"listItemNoBaground"}>
                                        <p>Other Charges:</p>
                                        <h2>{parseFloat( this.state.EstimatorDetails.otherCharges||0).toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}</h2>
                                    </div>
                                </div>
                            </div> : null}
                        </div>
                    </CardLayout>
                </div>
        );
    }
}

export default PackingMaterialCard;